import { useContext } from 'react';
import { storeContext } from '../storage';

export const useStorageContext = () => useContext(storeContext);